<script>
  import styles from './app.css'
  import Logo from './logo.svelte'
  import YearInput from './year-input/year-input.svelte'
  import Year from './year/year.svelte'
  import SnowflakeCanvas from './snowflake.svelte'
  import Footer from './footer.svelte'

  export let apiUrl
  export let landingPageUrl

  const MAX = 2022
  let year
  let age
  if (typeof window !== 'undefined') {
    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.get('birthyear') && typeof urlParams.get('age') !== 'undefined') {
      age = parseInt(urlParams.get('age'))
      const birthyear = parseInt(urlParams.get('birthyear'))
      if (birthyear + age > MAX) {
        age = MAX - birthyear
        year = MAX
      } else {
        age = age
        year = (birthyear + age).toString()
      }
    }
  }
</script>

<main class={styles.main}>
  {#if !year}
    <div class={styles.leftDecoration} />
    <div class={styles.rightDecoration} />
    <SnowflakeCanvas />
  {/if}
  <Logo />
  {#if !year}
    <div class={styles.inputWrapper}>
      <!-- TODO: Move this to YearInput -->
      <div class="wrapper">
        <YearInput {landingPageUrl} />
      </div>
    </div>
    <Footer showYearInput={false} />
  {:else}
    <Year {year} {apiUrl} {age} />
  {/if}
</main>

<style>
  .wrapper {
    position: relative;
  }
</style>
